export const getUserDisplayName = user => {
  if (typeof user === 'string') {
    return user;
  }

  return user?.name ?? '';
};
